import {
  getAuthenticatedThemisClient,
  DirectDebitBankAccountView,
} from '@modifi/onboarding-api-clients'
import {CollectionFactory, Reducer, AsyncAction} from '@modifi/redux'
import {createSelector} from 'reselect'
import {reducerKey} from './constants'

const apiClient = getAuthenticatedThemisClient()

type State = Record<string, any>

const {actions, selectors, reducer} = CollectionFactory({
  actionNamePrefix: 'data/directDebitBankAccount',
  reducerPath: ['data', reducerKey, 'collection'],
  fetchRequest: () =>
    apiClient.DirectDebitBankAccounts.fetch().then(res => res.data().directDebitBankAccounts!),
  entityPrimaryKeySelector: entity => entity?.externalId!,
})

export default reducer as Reducer

export const selectDirectDebitBankAccountsAreLoading = (state: State): boolean =>
  selectors.selectIsKeyWindowLoading(state, {})

const selectDirectDebitBankAccountsFetchCount = (state: State): number =>
  selectors.selectFetchCountByKeyWindow(state, {})

export const selectDirectDebitBankAccounts = (state: State): DirectDebitBankAccountView[] =>
  selectors.selectByKeyWindow(state, {}) || []

export const selectDirectDebitBankAccountByExternalId = (
  state: State,
  externalBankAccountId: string
): DirectDebitBankAccountView => selectors.selectById(state, externalBankAccountId)

export const selectDirectDebitBankAccountsWhereLoaded = createSelector(
  selectDirectDebitBankAccountsFetchCount,
  fetchCount => fetchCount > 0
)

export const selectMandateStatusByExternalId = createSelector(
  selectDirectDebitBankAccountByExternalId,
  directDebitAccount => directDebitAccount?.mandate?.mandateStatus || null
)

export const aUpdateDirectDebitBankAccount = (
  entity: Partial<DirectDebitBankAccountView>,
  merge = true
  // @ts-expect-error to be fixed
): AsyncAction => actions!.update(entity, merge)

export const aFetchDirectDebitBankAccounts = (): AsyncAction => actions!.fetch({})

export const aEnsureDirectDebitBankAccounts =
  (): AsyncAction =>
  (dispatch, getState): void => {
    if (
      selectDirectDebitBankAccountsAreLoading(getState()) ||
      selectDirectDebitBankAccountsWhereLoaded(getState())
    ) {
      return
    }
    dispatch(aFetchDirectDebitBankAccounts())
  }
